import { SelectItem } from 'primeng/components/common/api';
import { LoyaltyCatalogGiftReceivedStoreService } from 'app/services/loyalty/loyalty-catalog-gift-received-store.service';
import { LoyaltyGiftReservationService } from 'app/services/loyalty/loyalty-gift-reservation.service';
import { KoncentroValidators } from 'app/modules/UIKit/validators/koncentro-validators';
import { MinNumValidators } from 'app/views/loyalty/loyalty-catalog-gift-received-store/loyalty-catalog-gift-received-store-detail/min-num-validators';
import { CatalogGiftItemStoreReceived} from 'app/models/loyalty-catalog-gift-received-store.model';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormArray, FormBuilder, FormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/components/common/api';
import { MessageService } from 'primeng/api';
import * as moment from "moment";
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'app/services/user/auth.service';

@Component({
  selector: 'app-loyalty-catalog-gift-received-store-detail',
  templateUrl: './loyalty-catalog-gift-received-store-detail.component.html',
  styleUrls: ['./loyalty-catalog-gift-received-store-detail.component.css']
})
export class CatalogGiftReceivedStoreDetailComponent implements OnInit {

  catalogGiftReceivedStoreFields: any;
  catalogField: any;

  giftReceivedHeadId: number;
  userId: string;
  storeId;
  divisionId: number;
  catalogId: number;

  viewGiftItemForm: boolean = false;
  dateReceived: Date;
  loadGiftHead: boolean = false;
  removeButton: boolean = false;
  assignHeadId: number;

  itmFields: any;
  storeFields: any;
  article: any[];

  giftCode: SelectItem[] = [];
  giftStores: SelectItem[] = [];
  articleOption: SelectItem[] = [];
  articleOptionEdit: SelectItem[] = [];
  catalogOption: SelectItem[] = [];
  selectedStore: SelectItem;

  form: FormGroup;
  giftItem: FormGroup;
  invalidSubmit: boolean;
  isAssign: number = 0;
  isNotAssign: number = 0;
  counterForSendCommunication: number = 0;
  stores: Array<{data: SelectItem[], show: boolean}> = [];
  gift: Array<{data: SelectItem[], show: boolean}> = [];
  storeGroups: SelectItem[] = [];
  assignItem: CatalogGiftItemStoreReceived[] = [];
  assignedItem: CatalogGiftItemStoreReceived[] = [];
  stringAssignItm: string;
  timeout: any;
  message = {};
  articleInvalid: boolean = false;

  giftAssignConfirmMsg: string;
  sameGiftMultipleAssignErrorMsg: string;

  sameGiftMultipleAssign = false;

  duplicateItem: CatalogGiftItemStoreReceived[] = [];


  //Validators per il num_received, nel caso che dev'essere positivo e nel caso di modifica non dev'essere minore del valore num_received iniziale
  validators ={
    integerNotNegative: KoncentroValidators.integerNotNegative,
    numMin: MinNumValidators.numMin
  }



  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private giftReceivedService: LoyaltyCatalogGiftReceivedStoreService,
    public confirmationService: ConfirmationService,
    private divisionService: LoyaltyGiftReservationService,
    private messageService: MessageService,
    private translate: TranslateService,
    private router: Router
  ) { }

  get f() {
    return this.form.controls;
  }

  get giftItemRec(): FormArray {
    return this.form.get('giftItemRec') as FormArray;
  }

  ngOnInit() {

    // Recupero DTO FORM
    this.giftReceivedService.getCatlogGiftFields().subscribe(res => this.catalogGiftReceivedStoreFields = res);
    this.giftReceivedService.getCatlogGiftItemFields().subscribe(res => this.itmFields = res);
    //this.giftReceivedService.getCatalogFields().subscribe(res => this.catalogField = res);

    this.translate.get([
      'loyalty.giftAssign',
      'loyalty.giftNotAssigned',
      'loyalty.giftPartialAssigned',
      'brandList.add_title',
      'common.save_ok',
      'common.update_ok',
      'loyalty.itemDeleted',
      'catalog.giftAssignConfirm',
      'catalog.sameGiftMultipleAssignError'
    ]).subscribe((res) => {
      this.message['giftAssign'] = res['loyalty.giftAssign'];
      this.message['giftNotAssigned'] = res['loyalty.giftNotAssigned'];
      this.message['giftPartialAssigned'] = res['loyalty.giftPartialAssigned'];
      this.message['add_title'] = res['brandList.add_title'];
      this.message['save_ok'] = res['common.save_ok'];
      this.message['update_ok'] = res['common.update_ok'];
      this.message['itemDeleted'] = res['loyalty.itemDeleted'];
      this.giftAssignConfirmMsg = res['catalog.giftAssignConfirm'];
      this.sameGiftMultipleAssignErrorMsg = res['catalog.sameGiftMultipleAssignError'];
    });

    //Verifico che esista uno Store e ne recupero l'id
    this.giftReceivedHeadId = this.activatedRoute.snapshot.params['id'];

    //Controllo se esista l'head id e se stiamo nella pagina di edit
    if(this.giftReceivedHeadId){

      //Popolo il form del Gift Head Rec
      this.giftReceivedService.getCatalogGiftData(this.giftReceivedHeadId).subscribe(giftData =>{
        this.form = this.fb.group({
          store_name: [giftData[0]['store_name']],
          dt_received: [new Date (giftData[0]['dt_received'])],
          ship_note: [giftData[0]['ship_note']],
          store_id: [giftData[0]['store_id']],
          giftItemRec: new FormArray([]),
          host_code: [giftData[0]['host_code']]
        });

        this.giftStores.push({value: this.form.get('store_id').value, label: this.form.get('store_name').value});
        this.selectedStore = {label: this.form.get('host_code').value + " - " + this.form.get('store_name').value, value: this.form.get('store_id').value }
        this.loadGiftHead = true;

        //Popolo i form degli Articoli Gift item del record
        this.giftReceivedService.getCatalogGiftItemData(this.giftReceivedHeadId).subscribe(response =>{
          response.forEach((el, i) => {
            this.giftItemRec.push(this.fb.group({}));

            this.articleOption.push({label: `${el.catalog_gift_itm_code} - ${el.catalog_gift_description}`, value: `${el.catalog_gift_itm_code}`});

            this.giftItemRec.controls[i] = this.getGiftItem(el);
          })
        })
      })

    }
    else{
      //Carico il nuovo form in pagina se siamo nella pagina Aggiungi
      this.loadData();
    }
  }

  /**
   * Metodo per salvare una nuova ricezione premi o la modifica di una specifica ricezione premi
   * con controllo se il form Head Gift e Gift Item Article sono validi (usando i validator specificati all'inizio del componente)
   * @returns
   */
  save(){

    this.giftItemRec.setErrors(null);
    this.sameGiftMultipleAssign = false;
    this.duplicateItem = [];

    //Faccio il controllo per ogni Gift Item Article se il form sia valido
    this.giftItemRec.controls.forEach(el => {

      if(!el.valid){
        this.giftItemRec.setErrors({'incorrect': true});

      }

      if (this.assignItem.find(item => item.catalog_gift_itm_code === el.get('catalog_gift_itm_code').value.value)){
        this.messageService.add({severity: 'error', summary: 'Error', detail: this.sameGiftMultipleAssignErrorMsg});
        return;
      }


    })

    if (!this.form.valid ) {
      this.invalidSubmit = true;
      return;
    }


    this.invalidSubmit = false;
    const giftDataHead = {
      store_name: this.f.store_name.value,
      dt_received: moment(this.f.dt_received.value).format('YYYY-MM-DD'),
      ship_note: this.f.ship_note.value,
      store_id: this.f.store_id.value,
    }


    //Inserisco ogni articolo all'interno di un array di Gift Item Article e infine faccio la chiamata per l'assegnazione
    this.giftItemRec.controls.forEach(el => {
      // Verifica se stesso articolo assegnato piú volte
      if (this.duplicateItem.find(item => item.catalog_gift_itm_code === el.get('catalog_gift_itm_code').value.value)) {
        this.sameGiftMultipleAssign = true;
        this.confirmationService.confirm({
          message: this.sameGiftMultipleAssignErrorMsg,
          key: 'duplicateAssignError',
          acceptLabel: 'Ok',
          rejectVisible: false
        });
      } else {
        this.duplicateItem.push({
          id: el.get('id').value,
          catalog_gift_itm_code: el.get('catalog_gift_itm_code').value.value,
          num_received: el.get('num_received').value,
          num_assigned: el.get('num_assigned').value})
        }
    });

    //controllo se esista l'head id di un Gift Received
    if(this.giftReceivedHeadId){
      if (!this.form.valid ) {
        this.invalidSubmit = true;
        return;
      }


      this.invalidSubmit = false;

      if(!this.sameGiftMultipleAssign){

        //Chiamata per l'update del form di ricezione premi
        this.giftReceivedService.updateCatalogGift(this.giftReceivedHeadId, giftDataHead).subscribe(()=>this.router.navigate(['loyalty/catalog-gift-received-store']));
        if (this.giftItemRec && this.giftItemRec.length > 0) {
          this.giftItemRec.controls.forEach(itm => {
            const giftItemSnd = {
              reserv_gift_head_id: this.giftReceivedHeadId,
              catalog_gift_itm_code: itm.get('catalog_gift_itm_code').value.value,
              num_received: itm.get('num_received').value,
              num_assigned: itm.get('num_assigned').value
            };
            if (itm.get('id').value) {
              this.giftReceivedService.updateCatalogGiftItem(itm.get('id').value, giftItemSnd).subscribe(() => {
                this.messageService.add({severity: 'info', summary: 'Success', detail: this.message['update_ok']})
                this.router.navigate(['loyalty/catalog-gift-received-store']);
              });
            } else {
              this.giftReceivedService.createCatalogGiftItem(giftItemSnd).subscribe(() => {
                this.messageService.add({severity: 'info', summary: 'Success', detail: this.message['update_ok']})
                this.router.navigate(['loyalty/catalog-gift-received-store']);
              });
            }
          });
        }
      }
    } else{

      if(!this.sameGiftMultipleAssign){
        //Creo una nuova ricezione premi
        this.giftReceivedService.createReceivedCatalogGift(giftDataHead).subscribe(res => {
          this.giftItemRec.controls.forEach(itm => {
            const giftItemSnd = {
              reserv_gift_head_id: res.id,
              catalog_gift_itm_code: itm.get('catalog_gift_itm_code').value.value,
              num_received: itm.get('num_received').value,
              num_assigned: itm.get('num_assigned').value
            }
            this.giftReceivedService.createCatalogGiftItem(giftItemSnd).subscribe(() =>
              this.messageService.add({severity: 'info', summary: 'Success', detail: this.message['save_ok']})
            );
          })
          this.assignHeadId = res.id;
          this.router.navigate(['loyalty/catalog-gift-received-store']);
        })
      }
    }
  }

  confirmGiftAssign() {
    this.confirmationService.confirm({
      message: this.giftAssignConfirmMsg,
      acceptLabel: 'SI',
      accept: () => this.addGiftAssigned(),
      rejectVisible: true,
      rejectLabel: 'NO'
    });
  }


  /**
   * Metodo che salva il form con gli eventuali articoli e li assegna, sia in caso di aggiungi e di modifica
   * fa il controllo se il form e gli articoli siano validi, una volta salvati viene richiamato il metodo assignGift()
   * che assegna gli articoli salvati precedentemente
   */
  addGiftAssigned(){

    this.giftItemRec.setErrors(null);
    this.sameGiftMultipleAssign = false;
    this.duplicateItem = [];

    //Faccio il controllo per ogni Gift Item Article se il form sia valido
    this.giftItemRec.controls.forEach(el => {

      if(!el.valid){
        this.giftItemRec.setErrors({'incorrect': true});
      }

    })

    if (!this.form.valid ) {
      this.invalidSubmit = true;
      return;
    }

    this.invalidSubmit = false;
    const giftDataHead = {
      store_name: this.f.store_name.value,
      dt_received: moment(this.f.dt_received.value).format('YYYY-MM-DD'),
      ship_note: this.f.ship_note.value,
      store_id: this.f.store_id.value,
    }

    //Inserisco ogni articolo all'interno di un array di Gift Item Article e infine faccio la chiamata per l'assegnazione
    this.giftItemRec.controls.forEach(el => {
      // Verifica se stesso articolo assegnato piú volte
      if (this.duplicateItem.find(item => item.catalog_gift_itm_code === el.get('catalog_gift_itm_code').value.value)) {
        this.sameGiftMultipleAssign = true;
        this.confirmationService.confirm({
          message: this.sameGiftMultipleAssignErrorMsg,
          key: 'duplicateAssignError',
          acceptLabel: 'Ok',
          rejectVisible: false
        });
      } else {
        this.duplicateItem.push({
          id: el.get('id').value,
          catalog_gift_itm_code: el.get('catalog_gift_itm_code').value.value,
          num_received: el.get('num_received').value,
          num_assigned: el.get('num_assigned').value})
        }
    });

    //controllo se esista l'head id di un Gift Received
    if(this.giftReceivedHeadId){
      if (!this.form.valid ) {
        this.invalidSubmit = true;
        return;
      }


      this.invalidSubmit = false;
      if(!this.sameGiftMultipleAssign){
        //Chiamata per l'update del form di ricezione premi
        this.giftReceivedService.updateCatalogGift(this.giftReceivedHeadId, giftDataHead).subscribe(res=>{
        if (this.giftItemRec && this.giftItemRec.length > 0) {
          this.giftItemRec.controls.forEach(itm => {
            const giftItemSnd = {
              reserv_gift_head_id: this.giftReceivedHeadId,
              catalog_gift_itm_code: itm.get('catalog_gift_itm_code').value.value,
              num_received: itm.get('num_received').value,
              num_assigned: itm.get('num_assigned').value
            };
            if (itm.get('id').value) {
              this.giftReceivedService.updateCatalogGiftItem(itm.get('id').value, giftItemSnd).subscribe(()=>{
                this.assignGiftSingle(giftItemSnd);
              });
            } else {
              this.giftReceivedService.createCatalogGiftItem(giftItemSnd).subscribe(()=>{
                this.assignGiftSingle(giftItemSnd);
              });
            }

          })
          //this.assignGift();
          this.messageService.add({severity: 'info', summary: 'Success', detail: this.message['update_ok']});
          //this.router.navigate(['loyalty/catalog-gift-received-store'])
        }
        });;
      }
    }else{
      //questa casistica rientra in una nuova prenotazione premi appena create e l'utente clicca sul tasto assegna senza passare per il salv
      if(!this.sameGiftMultipleAssign){
          //Creo una nuova ricezione premi
          this.giftReceivedService.createReceivedCatalogGift(giftDataHead).subscribe(res => {

            this.giftItemRec.controls.forEach(itm => {
              const giftItemSnd = {
                reserv_gift_head_id: res.id,
                catalog_gift_itm_code: itm.get('catalog_gift_itm_code').value.value,
                num_received: itm.get('num_received').value,
                num_assigned: itm.get('num_assigned').value
              }
              this.giftReceivedService.createCatalogGiftItem(giftItemSnd).subscribe(resItem =>{
                this.assignHeadId = res.id;
                this.messageService.add({severity: 'info', summary: 'Success', detail: this.message['save_ok']})
                this.assignGiftSingle(resItem);
              }
              );
            })
            //setto il reservation_head_id
            //this.assignHeadId = res.id;
            //Assegno gli articoli - KS-4038 fix
            //this.assignGift();
            //this.router.navigate(['loyalty/catalog-gift-received-store'])  
          })
      }
    }
  }


  /**
   * Metodo che assegna gli articoli del form
   * vengono inseriti in un array, poi mandati nella chiamata POST assignGift del service GiftReceivedService.
   * viene visualizzato un messaggio in base all'esito dell'assegnazione, se sono stati assegnati, se non sono stati assegnati oppure se assegnati parzialmente.
   */
   assignGift(){
    //Inserisco ogni articolo all'interno di un array di Gift Item Article e infine faccio la chiamata per l'assegnazione
    this.giftItemRec.controls.forEach(el => {
      if(el.get('id').value != ""){
        this.assignItem.push({
          id: el.get('id').value,
          catalog_gift_itm_code: el.get('catalog_gift_itm_code').value.value,
          num_received: el.get('num_received').value,
          num_assigned: el.get('num_assigned').value})
        }
    });


    if(!this.giftReceivedHeadId){
      this.giftReceivedHeadId = this.assignHeadId;
    }

    //Chiamata per l'assegnazione dei premi, se i premi sono stati assegnati o non, vengono visualizzati i relativi messaggi
    this.giftReceivedService.assignGift(this.form.get('store_id').value, this.giftReceivedHeadId, this.authService.user.selectedCompany ,this.assignItem).subscribe(
      res => {
        res.forEach(itm => {
          if(itm.gift_assigned == true){
            this.isAssign = this.isAssign + 1;

            itm.listaPrenotazioni.forEach(el => {
              this.assignedItem.push({
                id: el.id
              });
            });

          }
          if(itm.gift_assigned == false ){
            this.isNotAssign = this.isNotAssign + 1;
          }

        });

        const strAssign: number[] = [];
        this.assignedItem.forEach(itm =>{
          strAssign.push(itm.id)
        });
        this.stringAssignItm = strAssign.join();


        if(this.isAssign > 0 ){
          //Premi assegnati
          if(this.isNotAssign == 0){this.messageService.add({severity: 'success', summary: 'Success', detail: this.message['giftAssign']});}
          //Premi assegnati parzialmente
          if(this.isNotAssign > 0){this.messageService.add({severity: 'success', summary: 'Success', detail: this.message['giftPartialAssigned']});}
          //chiamata al servizio di invio comunicazione al customer dei premi da ritirare in negozio
          this.giftReceivedService.sendCommunicationPickupReservationItem(this.form.get('store_id').value, this.giftReceivedHeadId, this.stringAssignItm).subscribe();
        }else{this.messageService.add({severity: 'info', summary: 'Success', detail: this.message['giftNotAssigned']});}
        this.router.navigate(['loyalty/catalog-gift-received-store']);
      }
    );

  }

  /**
   * Metodo che assegna un articolo del form al cliente, il metodo sarà chiamato n volte quanti sono i premi
   * utile nel caso l'utente clicchi sull'assegnazione diretta senza passare per il tasto salva
   * viene visualizzato un messaggio in base all'esito dell'assegnazione, se sono stati assegnati, se non sono stati assegnati oppure se assegnati parzialmente.
   */
   assignGiftSingle(gift_item_saved: any){

    if(!this.giftReceivedHeadId){
      this.giftReceivedHeadId = this.assignHeadId;
    }

    //Chiamata per l'assegnazione dei premi, se i premi sono stati assegnati o non, vengono visualizzati i relativi messaggi
    this.giftReceivedService.assignGiftSingle(this.form.get('store_id').value, this.giftReceivedHeadId, this.authService.user.selectedCompany ,gift_item_saved.catalog_gift_itm_code, gift_item_saved).subscribe(
      res => {
        res.forEach(itm => {
          if(itm.gift_assigned == true){
            this.isAssign = this.isAssign + 1;

            itm.listaPrenotazioni.forEach(el => {
              this.assignedItem.push({
                id: el.id
              });
            });

          }
          if(itm.gift_assigned == false ){
            this.isNotAssign = this.isNotAssign + 1;
          }
        this.counterForSendCommunication++;
        });

        const strAssign: number[] = [];
        this.assignedItem.forEach(itm =>{
          strAssign.push(itm.id)
        });
        this.stringAssignItm = strAssign.join();


        if(this.isAssign > 0 ){
          //Premio assegnati
          if(this.isNotAssign == 0){this.messageService.add({severity: 'success', summary: 'Success', detail: this.message['giftAssign']});}
          //Premio assegnati parzialmente
          if(this.isNotAssign > 0){this.messageService.add({severity: 'success', summary: 'Success', detail: this.message['giftPartialAssigned']});}
          //chiamata al servizio di invio comunicazione al customer dei premi da ritirare in negozio solo se tutti i premi  sono passati per la possibile assegnazione
          if(this.counterForSendCommunication === this.giftItemRec.length){
            this.sendCommunicationForReservation()
          }
        }else{
          this.messageService.add({severity: 'info', summary: 'Success', detail: this.message['giftNotAssigned']});
        }
        //caso in cui ho cliccato su assegnazione premi, non ho assegnato nessun premio, ma devo ritornare alla pagina precedente perchè
        //ha ciclato su tutti i premi
        if(this.counterForSendCommunication === this.giftItemRec.length){
          this.router.navigate(['loyalty/catalog-gift-received-store']);
        }

      }
    );

  }

  sendCommunicationForReservation(){
      this.giftReceivedService.sendCommunicationPickupReservationItem(this.form.get('store_id').value, this.giftReceivedHeadId, this.stringAssignItm).subscribe(res=>{
        this.counterForSendCommunication = 0;
      }
      );
  }

  /**
   * Chiama un metodo del servizio StoreCommonService per ottenere
   * i negozi relativi all'operatore e li aggiunge in un array che verrà visualizzato dal dropdown
   * se nella prima response l'utente non ha lo store_id allora esso avrà un division_sales_network_id
   * di conseguenza se l'utente ha il division_sales_network_id verrà chiamato il metodo loadDivisionStore()
   * che caricherà, in base al division_sales_network_id, nel dropdown i negozi della division di cui fa parte l'utente
   */
  loadData() {
    /*this.storeCommonService.getUserStoresAndSalesNetworks(this.userId).subscribe(response => {
      response.forEach((r) => this.giftStores.push({value: r.store_id, label: r.store_name})); //aggiungere possibile controllo se un record ha sia store_id che division_sales_network_id
      //this.loadCatalog(this.storeId); //dropdown catalog

      response.forEach(el => this.divisionId  = el.division_sales_network_id);
      */
      this.loadDivisionStore();
  }

  /**
   * Metodo per ottenere i negozi di una division, solo nel caso che l'utente abbia
   * un division_sales_network_id
   */
  loadDivisionStore(){
    this.userId = this.authService.user.id.toString();
    this.giftStores = [];
    this.divisionService.getStores().subscribe(res => {
      res.forEach(el => this.giftStores.push({value: el.id, label: `${el.host_code} - ${el.name}`}));
      this.loadForm();
    });
  }


  /**
   * Metodo per generare ed eventualmente popolare il form per un catalog_gift_itm
   * @param giftItm
   * @returns
   */
  getGiftItem(giftItm?) {
    return this.fb.group({
      id: [giftItm ? giftItm.id : ''],
      reservation_gift_head_id: giftItm ? new FormControl({value: giftItm.reserv_gift_head_rec, disabled: true}) : [''],
      catalog_gift_itm_code: giftItm ?  new FormControl({ value: { value: giftItm.catalog_gift_itm_code, label: `${giftItm.catalog_gift_itm_code} - ${giftItm.catalog_gift_description}` }, disabled: true }) : [''],
      num_received: giftItm ? new FormControl({value: giftItm.num_received, disabled: false}) : [''],
      num_assigned: giftItm ? new FormControl({value: giftItm.num_assigned, disabled: true}) : ['0'],
      numMin: giftItm ? new FormControl({value: giftItm.num_received, disabled: false}) : ['1'],
    });
  }


  /**
   * Metodo per aggiungere un nuovo form di Gift Item
   */
  addGiftItemReceived() {
    this.gift.push({data: [], show: false});
    this.giftItemRec.push(this.getGiftItem());
    this.removeButton = true;
    this.articleInvalid = true;
  }


  /**
   * Metodo per rimuovere un determinato form Gift Item
   * @param id
   * @param index
   */
  removeGiftItemReceived(id: number, index: number) {
    this.gift.splice(index, 1);
    if (id) {
      this.giftReceivedService.deleteCatalogGiftItem(id).subscribe(() => this.giftItemRec.removeAt(index));
      this.messageService.add({severity: 'info', summary: 'Success', detail: this.message['itemDeleted']});
    } else {
      this.giftItemRec.removeAt(index);
    }
    this.articleInvalid = false;

  }

  /**
   * Metodo per caricare i catalog id nel dropdwon del form Gift Item
   */
  loadCatalog(storeId){
    this.giftReceivedService.getCatalogOfStore(storeId).subscribe(catalog => {
      catalog.forEach(el => {
        this.catalogOption.push({value: el.id, label: el.description})
      });
    })
  }

   /**
    * Metodo per generare un nuovo form
    * Per l'eventualità di un dropdown con catalog
    * aggiungere nel form = catalog_id: [''],
    */
   loadForm(){
     this.form = this.fb.group({
       store_name: [''],
       dt_received: [new Date()],
       ship_note: [''],
       store_id: this.giftStores.length === 1 ? [this.giftStores[0].value] : [''],
       giftItemRec: new FormArray([]),
       host_code: ['']
     });
   }


  /**
   * Metodo per la ricerca di un articolo tramite codice o descrizione
   * la risposta viene pushata in un array
   * @param event prende come parametro la lettera / numero inserito per la ricerca dell'articolo
   */
  searchArticle(event) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.giftReceivedService.getGiftForReservationList(this.form.get('store_id').value, event.query).subscribe(res => {
      this.articleOption = res;
    }), 1000);
  }

  /**
   * Metodo per la scelta dell'articolo, setta il valore nel form dell'articolo scelto
   * @param event
   */
  onSelectArticle(event, i){
    this.giftItemRec.controls[i].get('catalog_gift_itm_code').value.value = event.value;
    this.articleInvalid = false;
  }


  /**
   * Metodo che pulisce il campo del form dell'articolo se viene cancellato il valore nell'input
  */
  onClearArticle(){
    this.form.get('catalog_gift_itm_code').setValue(null);
    this.articleInvalid = true;
  }

  
  changeStore(event) {
    this.selectedStore = event;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-catalog-gift-received-store/loyalty-catalog-gift-received-store-detail/loyalty-catalog-gift-received-store-detail.component.ts